import React from "react";
import { useState } from 'react';
//React Router
import { useNavigate } from 'react-router-dom'

// tools and component for date picker
import dayjs from 'dayjs';

//selectors for redux :
import { useSelector } from "react-redux";
import { getIdSpotLoc, getLivraison, getRidingPeriod, getPanier, getUserData, getCommentaire, getAccess, getContrat } from "../../../../../../store/selectors.js";
import { useDispatch } from "react-redux";
import { contratSlice } from "../../../../../../store/contratSlice.js";
import { contratStepSlice } from "../../../../../../store/contratStepSlice.js";

//MUI Components
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Alert from '@mui/material/Alert';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import MoneyIcon from '@mui/icons-material/Money';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PaymentsIcon from '@mui/icons-material/Payments';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';



//import Fetch API functions
import { getArticles, getOneSpot, getAllTarifs, getAccessoires } from '../../../../../../database/fetchApi.js'

//created components
import BlocRecap from '../../../../../../steps/step5/components/blocrecap/BlocRecap.jsx'

//Utils functions
import { prepareDureeTexte } from '../../../../../../utils/calcul_duree.js'
import calculDuree from '../../../../../../utils/calcul_duree.js' //we import this method because there is a bug to store the duree in Redux (infinite loop)
import { calcPrixDegressif } from "../../../../../../utils/calcul_prix.js" //parms : tarifs object, duree object
import { prepAdresse } from '../../../../../../utils/prepa_adresse_paiement.js'; //url preparation for axepta
import prepaMailContrat from "../../../../../../utils/prepa-mail-contrat.js" //params : fullContrat 

// API fetch
import axios from "axios";
import { baseURL, cloudRunBaseURL } from '../../../../../../config/api-config.js';
import { IndeterminateCheckBoxOutlined } from "@mui/icons-material";

function StepSix() { // component to manage the first step of shopping : choosing place and time

    const [articles, setArticles] = useState([]);
    const [accessoires, setAccessoires] = useState([]);
    const [tarifs, setTarifs] = useState([]);
    const [spotInfos, setSpotInfos] = useState(null); //null is set by default so we can 
    const [fail, setFail] = useState(false); //state : api request failed
    const [infos, setInfos] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [ref, setRef] = React.useState("");
    const [contratID, setContratID] = React.useState();
    const [paymentUrl, setPaymentUrl] = useState(""); //state : api request failed
    const [lock, setLock] = useState(true); //state : modify total price
    const [showLoading, setShowLoading] = useState(false);

    let successRequest = 0;

    const idSpot = useSelector(getIdSpotLoc); //global state : id of the selected spo
    const accessList = useSelector(getAccess); //global state : id of the selected spo
    const infosLivraison = useSelector(getLivraison); //global state : id of the selected spo
    const period = useSelector(getRidingPeriod); //global state : id of the selected spo
    const userInfos = useSelector(getUserData); //global state : id of the selected spo
    let panier = useSelector(getPanier); //get global state : panier
    let commentaire = useSelector(getCommentaire); //get global state : panier
    let currentContrat = useSelector(getContrat); //get global state : panier

    const dureeObject = calculDuree(period); //get object with quantity for every durations (demis,jour, semaine...)

    let periode = useSelector(getRidingPeriod);

    const [customPrice, setCustomPrice] = useState(0); //state : modify total price
    const [cumulPrice, setCumulPrice] = useState(0); //state : modify total price
    const [priceError, setPriceError] = useState(false); //state : modify total price
    const [paiementModes, setPaiementModes] = useState([{ type: 2, montant: 0 }]); //state : modify total price
    const [cumulError, setCumulError] = useState(false); //state : modify total price
    const [cautionType, setCautionType] = useState(0); //state : modify total price
    const [cautionDetails, setCautionDetails] = useState(currentContrat.garantie); //state : modify total price
    const [comment2, setComment2] = useState(currentContrat.commentaire2); //state : modify total price
    const [mailChecked, setMailChecked] = useState(true); //state : modify total price
    const [insertError, setInsertError] = useState(""); //state : modify total price
    //let paiementModes = [{ type: 2, montant: 0 }];
    let paiementModesList = [
        { type: 2, intitule: "Espèces" },
        { type: 3, intitule: "CB" },
        { type: 4, intitule: "Chèque" },
        { type: 5, intitule: "ANCV" },
        { type: 6, intitule: "Virement" }
    ];

    let garantiesList = [
        "- Choisissez -", "Pièce d'identité", "Empreinte CB", "Chèque", "Autre"
    ];


    const dispatch = useDispatch();
    const navigate = useNavigate();


    React.useEffect(() => { //change opening hours when spot change (idspot as dependency)

        async function initArticles() { //we add this inner function to manage asynchrone
            let allArticles = await getArticles();
            setArticles([].concat(allArticles))
        } //end of async function
        initArticles(); //call the inner asnchrone function

        async function initAccessoires() { //we add this inner function to manage asynchrone
            let allAccessoires = await getAccessoires();
            setAccessoires([].concat(allAccessoires))
        } //end of async function
        initAccessoires(); //call the inner asnchrone function

        async function initSpot() { //we add this inner function to manage asynchrone
            let infosSpot = await getOneSpot(idSpot);
            setSpotInfos(infosSpot)
        } //end of async function
        initSpot(); //call the inner asnchrone function 

        async function initTarifs() { //we add this inner function to manage asynchrone
            let allTarifs = await getAllTarifs();
            setTarifs(allTarifs)
        } //end of async function
        initTarifs(); //call the inner asnchrone function 

        console.log("rendu");
        //setCustomPrice(getCumul().total);
    }, [])

    React.useEffect(() => { //reset customprice on lock
        if (lock === true) {
            setCustomPrice(getCumul().du);
        }
    }, [lock])

    React.useEffect(() => { //reset customprice on lock

        if (panier.length > 0 && articles.length > 0) {
            setCustomPrice(getCumul().du);
            setPaiementModes([{ type: 2, montant: getCumul().du }])

        }

    }, [panier, articles])


    const handlePriceChange = e => {

        setCustomPrice(e.target.value);

        if (e.target.validity.valid) {
            setPriceError(false);
        } else {
            setPriceError(true);
        }
    };


    function changeMontantPaiement(index, value) {

        let newList = [];
        let cumul = 0;

        for (let i = 0; i < paiementModes.length; i++) {
            if (i === index) {
                newList.push({ type: paiementModes[i].type, montant: value });
                cumul += parseInt(value);
            } else {
                newList.push(paiementModes[i]);
                cumul += parseInt(paiementModes[i].montant);
            }
        }

        setCumulError(parseInt(customPrice) !== cumul);
        setPaiementModes(newList);

    }

    function changeTypePaiement(index, value) {

        let newList = [];

        for (let i = 0; i < paiementModes.length; i++) {
            if (i === index) {
                newList.push({ type: value, montant: paiementModes[i].montant });
            } else {
                newList.push(paiementModes[i]);
            }
        }
        setPaiementModes(newList);

    }

    function getPaiementIcon(type) {

        let paiementModesListIcons = [
            <PaymentsIcon />,
            <CreditCardIcon />,
            <MoneyIcon />,
            <ReceiptLongIcon />,
            <SaveAltIcon />
        ];

        return (paiementModesListIcons[type - 2])
    }



    function findArticle(id) {
        try {
            return articles.find((item) => item.id_article === id);

        }
        catch {
            //console.log('error find')
        }
    }

    function getCumul() {
        let total = 0;
        let lignes = [];

        if (panier.length > 0) {
            panier.map((ligne) => {
                let articleCourant = findArticle(ligne.id_article);
                if (typeof articleCourant !== 'undefined') {
                    let pu = ligne.qte * calcPrixDegressif(articleCourant.Tarif, calculDuree(periode));
                    //let infosArticle = ligne.qte + " x " + articleCourant.type + " : " + pu + ",00€";
                    let infosArticle = { qte: ligne.qte, type: articleCourant.type, pu };
                    total += pu;
                    lignes.push(infosArticle);
                }
            });
        }

        let du = total - currentContrat.total > 0 ? total - currentContrat.total : 0;

        return { total, lignes, du };
    }


    function checkReady() {
        let cumul = 0;
        paiementModes.forEach((paiement) => {
            cumul += parseInt(paiement.montant);
        });

        return (priceError || cumulError || (parseInt(customPrice) !== cumul) || cautionDetails.length === 0)
    }


    function getUserInfos(infos) { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree
        return (
            <div className="bloc-recap-infos-user">
                <p>{infos.prenom} {infos.nom}</p>
                <div className="bloc-recap-infos-user-bloc">
                    <p>{infos.tel}</p>
                    <p>{infos.email}</p>
                </div>
                <div className="bloc-recap-infos-user-bloc">
                    <p>{infos.adresse}, {infos.adresse_comp}</p>
                    <p>{infos.cp}, {infos.ville}, {infos.pays}</p>
                </div>



            </div>
        )
    }

    function getPeriodInfos() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree

        let dateDeb = "";
        let dateFin = "";
        let duree = "";

        //prepare dates infos
        dateDeb += "du " + dayjs(period[0][0]).format("DD/MM/YYYY");
        dateDeb += " à " + period[1][0] + "h00";
        dateFin += " au " + dayjs(period[0][1]).format("DD/MM/YYYY");
        dateFin += " à " + period[1][1] + "h00";

        //Prepare duree infos
        duree = prepareDureeTexte(dureeObject);

        return (
            <div className="bloc-recap-infos-duree">
                <p className="bloc-recap-infos-duree-date">{dateDeb}</p>
                <p className="bloc-recap-infos-duree-date">{dateFin}</p>
                <p className="bloc-recap-infos-duree-cumul">soit : {duree}</p>
            </div>
        )
    }

    function getSpotInfos() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree

        let spot1 = "";
        let spot2 = "";

        // prepare spot infos
        if (idSpot >= 99) {
            spot1 = "Livraison : " + infosLivraison.secteur; // if spot is 'Livraison' (id=99), we collect secteur and adresse from object stored in global state
            spot2 = infosLivraison.adresse; // if spot is 'Livraison' (id=99), we collect secteur and adresse from object stored in global state
        }
        else { // spot is not livraion
            if (spotInfos) { // if promise not fullfilled yet, we block the process to evoid error
                spot1 = spotInfos.nom_spot;
                spot2 = spotInfos.adresse_spot + " " + spotInfos.ville_spot;
            }
        }

        return (
            <div className="bloc-recap-infos-spot">
                <p>{spot1}</p>
                <p>{spot2}</p>
            </div>
        )
    }

    function getLivraisonComp(comp) {
        let info = " ";
        info += comp === undefined ? "" : comp;
        return info;
    }

    function getCartInfos() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree
        let { total, lignes, du } = getCumul();


        return (
            <div className="bloc-recap-infos-cart">
                <div className="bloc-recap-infos-cart-top">
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Article</TableCell>
                                <TableCell align="center">Quantité</TableCell>
                                <TableCell align="center">Tarif</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {lignes.map((row) => (
                                <TableRow
                                    key={row.type}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.type}
                                    </TableCell>
                                    <TableCell align="center">{row.qte}</TableCell>
                                    <TableCell align="center">{row.pu},00€</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                </div>
                <div className="bloc-recap-infos-cart-modif">
                    <h3>Montant total du panier :</h3>
                    <p>{total},00 €</p>
                </div>

                <div className="bloc-recap-infos-cart-regle">
                    <h3>Déjà réglé :</h3>
                    <p>{currentContrat.total},00 €</p>
                </div>

                <div className="bloc-recap-infos-cart-total">

                    <h3>Restant dû :</h3>
                    <p>{du},00 €</p>
                </div>
                <div className="bloc-recap-infos-cart-bottom">
                    {
                        commentaire.length > 1 ? //display only if commentaire is set
                            <>
                                <h3>Commentaires :</h3>
                                <p>{commentaire}</p>
                            </>
                            : null
                    }

                </div>



            </div>
        )
    }


    function getAccessInfos() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree
        // let { total, lignes } = getCumul();

        return (
            <div className="bloc-recap-infos-cart">
                <div className="bloc-recap-infos-cart-top">
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Acessoires</TableCell>
                                <TableCell align="center">Quantité</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {accessList.map((row) => (
                                <TableRow
                                    key={row.id_article}
                                >
                                    <TableCell component="th" scope="row">
                                        {accessoires.length > 0 ? accessoires.find((info) => info.id_article === row.id_article).type : " "}
                                    </TableCell>
                                    <TableCell align="center">{row.qte}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                </div>

            </div>
        )
    }




    function modifContrat() {

        setShowLoading(true);

        let body = {
            date1: period[0][0],
            date2: period[0][1],
            h1: period[1][0],
            h2: period[1][1],
            total: getCumul().total,
            solde: 0,
            commentaire2: comment2,
            garantie: cautionDetails
        }

        axios.put(`${baseURL}/contrat/${currentContrat.id_contrat}`, body)
            .then((response) => {
                if (response.status === 200) { //isnertion OK
                    successRequest++;
                    insertLignes(response.data)
                }
                else { //insertion problème
                    setFail(true); //to trigger alert message
                    setInsertError("Erreur lors de la création du contrat. Vous pouvez essayer à nouveau");
                    return response.status
                }
            })
            .catch(error => {
                setFail(true); //to trigger alert message
                setInsertError("Erreur lors de la création du contrat. Vous pouvez essayer à nouveau");
                return error
            })

    }


    function insertLignes(dataContrat) {
        /*  console.log(dataContrat.data.id_contrat);
         console.log(dataContrat); */
        setContratID(dataContrat.data.id_contrat);
        let batch = [];

        panier.map((ligne) => { // for each article of the panier...
            let rendus = [];
            for (let i = 1; i <= ligne.qte; i++) { //init defaut rendu array according to qty
                rendus.push(0); //0 by default = false
            }

            let body = {//prepare the json body sent in request
                article_id: ligne.id_article,
                contrat_id: dataContrat.data.id_contrat,
                qte: ligne.qte,
                taille: ligne.tailles,
                prenom: ligne.prenoms,
                rendu: rendus
            }

            batch.push(body);


        })//end of map

        axios.post(`${baseURL}/contrat-article/bulk`, batch)
            .then((response) => {
                if (response.status === 201) { //isnertion OK
                    successRequest++;
                    setFail(false); //to not trigger alert message
                    // Next : 
                    deleteOldArticles();
                    console.log(response.data);

                }
                else { //insertion problème
                    setFail(true); //to trigger alert message
                    setInsertError("Erreur lors de l'ajout des articles. Vous pouvez essayer à nouveau");
                    return response.status
                }
            })
            .catch(error => {
                setFail(true); //to trigger alert message
                setInsertError("Erreur lors de l'ajout des articles. Vous pouvez essayer à nouveau");
                return error
            })

    }

    function deleteOldArticles() {

        let nbSuccess = 0;

        currentContrat.ContratArticles.map((ligne) => { // for each article of the panier...
            console.log(ligne.id)
            axios.delete(`${baseURL}/contrat-article/${ligne.id}`)
                .then((response) => {
                    if (response.status === 201) { //isnertion OK
                        nbSuccess++;
                        setFail(false); //to not trigger alert message
                        if (nbSuccess === currentContrat.ContratArticles.length) {
                            // Next : 
                            console.log("suppression articles ok");
                            insertAccess();
                        }


                    }
                    else { //insertion problème
                        setFail(true); //to trigger alert message
                        setInsertError("Erreur lors de la suppression des anciens articles." + response.status);
                        return response.status
                    }
                })
                .catch(error => {
                    setFail(true); //to trigger alert message
                    setInsertError("Erreur lors de la suppression des anciens articles.");
                    return error
                })
        })//end of map

    }

    function insertAccess() {

        let batch = [];

        accessList.map((ligne) => { // for each article of the panier...

            let body = {//prepare the json body sent in request
                article_id: ligne.id_article,
                contrat_id: currentContrat.id_contrat,
                qte: ligne.qte,
                rendu: 0
            }

            batch.push(body);


        })//end of map

        axios.post(`${baseURL}/contrat-access/bulk`, batch)
            .then((response) => {
                if (response.status === 201) { //isnertion OK
                    successRequest++;
                    setFail(false); //to not trigger alert message
                    // Next : 
                    deleteOldAccess()

                }
                else { //insertion problème
                    setFail(true); //to trigger alert message
                    setInsertError("Erreur lors de l'ajout des accessoires. Vous pouvez essayer à nouveau");
                    return response.status
                }
            })
            .catch(error => {
                setFail(true); //to trigger alert message
                setInsertError("Erreur lors de l'ajout des aaccessoires. Vous pouvez essayer à nouveau");
                return error
            })


    }

    function deleteOldAccess() {

        let nbSuccess = 0;

        currentContrat.ContratAccesses.forEach((ligne) => { // for each article of the panier...

            axios.delete(`${baseURL}/contrat-access/${ligne.id}`)
                .then((response) => {
                    if (response.status === 201) { //isnertion OK
                        nbSuccess++;
                        setFail(false); //to not trigger alert message
                        // Next : 
                        if (nbSuccess === currentContrat.ContratAccesses.length) {
                            // Next : 
                            console.log("suppression access ok");
                            fillCaisse(); //remplir les infos de caisse
                        }

                    }
                    else { //insertion problème
                        setFail(true); //to trigger alert message
                        setInsertError("Erreur lors de la suppression des anciens articles.");
                        return response.status
                    }
                })
                .catch(error => {
                    setFail(true); //to trigger alert message
                    setInsertError("Erreur lors de la suppression des anciens articles.");
                    return error
                })

        })//end of map

    }



    function fillCaisse() {

        // we force update just to get response with all jointured tables
        axios.put(`${baseURL}/contrat/${currentContrat.id_contrat}`, {
            solde: 0
        })
            .then((response) => {
                if (response.status === 200) { //isnertion OK

                    //// -- remplir caisee
                    let fullContrat = response.data.data; //remplir les infos de caisse
                    console.log(fullContrat)
                    let batch = [];

                    paiementModes.map((ligne) => { // for each article of the panier...

                        let body = {//prepare the json body sent in request{
                            contrat_id: fullContrat.id_contrat,
                            ref_contrat: fullContrat.ref_contrat,
                            type_paiement: ligne.type,
                            montant: ligne.montant,
                            date_paiement: dayjs().format("YYYY-MM-DD")
                        }

                        batch.push(body);


                    })//end of map



                    axios.post(`${baseURL}/caisse/bulk`, batch)
                        .then((response) => {
                            if (response.status === 201) { //isnertion OK
                                console.log(response.data)
                                sendMail(fullContrat);

                            }
                            else { //insertion problème
                                setFail(true); //to trigger alert message
                                setInsertError("Erreur lors de l'ajout des infos de caisse. Vous pouvez essayer à nouveau");
                                return response.status
                            }
                        })
                        .catch(error => {
                            setFail(true); //to trigger alert message
                            setInsertError("Erreur lors de l'ajout des infos de caisse. Vous pouvez essayer à nouveau");
                            return error
                        })




                }
                else { //insertion problème
                    return response.status
                    console.log(response.status);
                }
            })
            .catch(error => {
                return error
                console.log(error);
            })



    }




    function sendMail(fullContrat) {

        if (mailChecked === true) {

            let body = {
                //to: "manuel.vivion@gmail.com",
                to: fullContrat.Client.email,
                bcc: "sylvainboufflers2@gmail.com,manuel.vivion@gmail.com",
                subject: "[Contrat Location] - Modif - " + fullContrat.ref_contrat,
                html: prepaMailContrat(fullContrat, articles, accessoires, dureeObject, tarifs)
            };

            axios.post(`${baseURL}/mailing/mail-confirm`, body)
                .then((response) => {
                    setOpen(false) // --> fermer modal 

                    if (response.status === 200) { //isnertion OK

                        //Everything ok, so  we update contrat to confirm
                        axios.put(`${baseURL}/contrat/${fullContrat.id_contrat}`, {
                            paye: 2,
                        })
                            .then((response) => {
                                //// ---
                                //Manager Mode : 
                                setShowLoading(false);
                                dispatch(contratSlice.actions.setContrat(fullContrat)); //
                                dispatch(contratStepSlice.actions.nextContratStep()); //go to confirmation
                                /// --

                            })



                    }
                    else { //insertion problème

                        //// ---
                        setInsertError("Erreur lors de l'envoie du mail de confirmation. Vous pouvez essayer à nouveau");
                        /// --
                    }
                })
                .catch(error => {
                    setOpen(false) // --> fermer modal 
                    //// ---
                    setInsertError("Erreur lors de l'envoie du mail de confirmation. Vous pouvez essayer à nouveau");
                    /// --

                })
        }
        else {
            //Everything ok, so  we update contrat to confirm
            axios.put(`${baseURL}/contrat/${fullContrat.id_contrat}`, {
                paye: 2,
            })
                .then((response) => {
                    //// ---
                    //Manager Mode : 
                    dispatch(contratSlice.actions.setContrat(fullContrat)); //
                    dispatch(contratStepSlice.actions.nextContratStep()); //go to confirmation
                    /// --

                })
        }
    }


    return (
        <div className="step5">
            <div className="step5-top">
                <h1>Recapitulatif de votre commande avant paiement</h1>
            </div>
            <div className="step5-blocs">
                <div className="step5-blocs-left">
                    <BlocRecap step={1} edit={true} titre={"Votre point de location :"} infos={getSpotInfos()} />
                    <BlocRecap step={1} edit={true} titre={"Durée de location :"} infos={getPeriodInfos()} />
                    <BlocRecap step={2} edit={true} titre={"Vos articles :"} infos={getCartInfos()} />

                </div>
                <div className="step5-blocs-right">
                    <BlocRecap step={3} edit={true} titre={"Vos accessoires :"} infos={getAccessInfos()} />
                    <BlocRecap step={4} edit={true} titre={"Vos informations :"} infos={getUserInfos(userInfos)} />
                </div>

            </div>

            <div className="step6-custom-price">
                <h3>Tarif du contrat : </h3>
                <span onClick={_ => setLock(!lock)}>{lock === true ? <LockIcon /> : <LockOpenIcon />}</span>
                <TextField
                    id="outlined-basic"
                    disabled={lock}
                    label="Tarif final"
                    variant="outlined"
                    error={priceError}
                    onChange={handlePriceChange}
                    onBlur={(e) => e.target.value.length === 0 ? setCustomPrice(getCumul().du) : null}
                    value={customPrice}
                    inputProps={{
                        pattern: "^[0-9]*$",
                    }} />
                <p>,00€</p>
            </div>





            <div className="step6-mode-paiement">
                <h3>Moyens de paiement :</h3>

                {
                    paiementModes.map((paiement, index) => (
                        <div key={index} className="step6-mode-paiement-ligne">

                            {getPaiementIcon(paiementModes[index].type)}

                            <Select
                                className="step6-mode-paiement-ligne-select"
                                value={paiementModes[index].type}
                                label="Mode de paiement"
                                size="small"
                                onChange={e => changeTypePaiement(index, e.target.value)}
                            >
                                {paiementModesList.map((mode) =>
                                    <MenuItem key={mode.type} value={mode.type}>{mode.intitule}</MenuItem>
                                )}
                            </Select>
                            <TextField
                                className="step6-mode-paiement-ligne-textfield"

                                id="outlined-basic"
                                size="small"
                                label="Montant"
                                variant="outlined"
                                error={cumulError}
                                onChange={e => changeMontantPaiement(index, e.target.value)}
                                value={paiementModes[index].montant}
                                inputProps={{
                                    pattern: "^[0-9]*$",
                                }} />
                            <p>,00€</p>

                            {index > 0 ?
                                <Button
                                    className="step6-mode-paiement-bt-suppr"
                                    variant="contained"
                                    onClick={_ => setPaiementModes(paiementModes.toSpliced(index, 1))}
                                ><DeleteForeverIcon />
                                </Button>
                                : <span className="step6-mode-paiement-vide"></span>}
                        </div>
                    ))
                }

                <Button
                    className="step6-mode-paiement-bt-ajout"
                    variant="contained"
                    onClick={_ => setPaiementModes(paiementModes.concat([{ type: 2, montant: 0 }]))}
                >Ajouter un moyen de paiement
                    </Button>
            </div>


            <div className="step6-mode-paiement">
                <h3>Dépôt de garantie :</h3>
                <div className="step6-mode-paiement-ligne">
                    {/* <Select
                        className="step6-mode-paiement-ligne-caution"
                        value={cautionType}
                        label="Type de garantie"
                        size="small"
                        onChange={e => setCautionType(e.target.value)}
                    >
                        {garantiesList.map((gar, index) =>
                            <MenuItem key={index} value={index}>{gar}</MenuItem>
                        )}


                    </Select> */}
                    <TextField
                        className="step6-mode-paiement-ligne-caution-edit"
                        fullWidth
                        label="garantie"
                        variant="outlined"
                        onChange={e => setCautionDetails(e.target.value)}
                        value={cautionDetails} />


                </div>

            </div>

            <div className="step6-mode-paiement">
                <h3>Commentaire additionnel :</h3>
                <div className="panier-modal-bottom-commentaires">
                    <TextField
                        fullWidth
                        label="Commentaire 2"
                        placeholder="facultatif"
                        /* defaultValue=" " */
                        value={comment2}
                        onChange={e => setComment2(e.target.value)}
                        multiline
                        maxRows={3}
                    />
                </div>
            </div>

            <FormControlLabel
                className="contrat-location-middle-checkbox"
                /* required */
                control={<Checkbox
                    onChange={_ => setMailChecked(!mailChecked)}
                    checked={mailChecked}
                />}
                label="Envoyer mail de confirmation"

            />

            <div className="step5-bottom">
                {fail ?
                    <Alert
                        className="step5-bottom-alert"
                        severity="error">
                        Une erreur réseau s'est produite, nous ne pouvons passer au paiement.
                    </Alert>
                    : null
                }
                {cumulError ?
                    <Alert
                        className="step5-bottom-alert"
                        severity="error">
                        Le cumul des moyens de paiement ne correspond pas au montant à payer
                    </Alert>
                    : null
                }
                {insertError.length > 0 ?
                    <Alert
                        className="step5-bottom-alert"
                        severity="error">
                        {insertError}
                    </Alert>
                    : null
                }

                <Button
                    disabled={checkReady()}
                    className="bouton-valid-cmd"
                    variant="contained"
                    onClick={_ => modifContrat()}
                >Valider la commande
                </Button>
                {showLoading === true ?
                    <CircularProgress />
                    : null
                }



            </div>


        </div>

    )
}




export default StepSix